<template>
  <footer class="app-footer">
  
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// Footer.vue?d171685a